import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import * as XLSX from 'xlsx';
import { SESSION_STORAGE, StorageService } from 'ngx-webstorage-service';
import Swal from 'sweetalert2';
import { Router, RouterModule } from '@angular/router';
import { ApiService } from '../../../api.service';
import { AgGridAngular } from 'ag-grid-angular';
import { ExcelService } from 'src/app/excel.service';
type AOA = any[][];


@Component({
  selector: 'app-uploadexcelfint2',
  templateUrl: './uploadexcelfint2.component.html',
  styleUrls: ['./uploadexcelfint2.component.css']
})
export class Uploadexcelfint2Component implements OnInit {

  @ViewChild('fileControl') fileControl: ElementRef;
  timeLeft: number = 0;
  interval;
  data: AOA = [];
  wopts: XLSX.WritingOptions = { bookType: 'xlsx', type: 'array' };
  fileName: string = 'SheetJS.xlsx';
  file: any;
  arrayBuffer: any;
  Last_existing_count = 0;

  excel_data = [];
  loader_status = false;


  original_portfolio_list : any = [] ;
  original_bank_list : any = [] ;
  Bank_list : any  = [] ;
  product_list : any = [] ;
  original_product_list : any = [] ;
  portfolio_list : any = [] ;
  booleans = true;
  Bank_list_gets  : any;
  bank_id : any;
  portfolio_list_gets :  any;

  product_id = '';
  portfolio_id = '';
  product_list_gets = '';
  product_name : any;
  bucket_details = '';

  upload_visible = false;
  removeChars(str: string): string {
    return str ? str.replace(/"| /g, '') : '';
  }
  constructor(
    private router: Router,
    private _api: ApiService,
    private excelService: ExcelService,
    @Inject(SESSION_STORAGE) private storage: StorageService
  ) {

    this.Bank_list_get();
    this.product_list_get();
    this.portfolio_list_get();

   }

  ngOnInit(): void {




  }


  Bank_list_get() {
    // this._api.client_list().subscribe(
    //   (response: any) => {
    //     let list = response.Data.reverse();
    //     for (let i = 0; i < list.length; i++) {
    //       let obj = { "y": list[i].Clinet_name};
    //       this.Bank_list.push(obj);
    //     }

    //   }
    // );

    let a = {
      client_id : this.getFromLocal("Client_ID")
    }
    this._api.fetch_bank_list_by_client_id(a).subscribe(
      (response: any) => {
        this.original_bank_list = response.Data;
        this.Bank_list = [];
       var hash = response.Data.reduce((p,c) => (p[c.bank_name] ? p[c.bank_name].push(c) : p[c.bank_name] = [c],p) ,{});
       var  newData = Object.keys(hash).map(k => ({color: k, car: hash[k]}));
        for(let a = 0 ; a < newData.length; a ++){
          let x =  { 'y': newData[a].color}
          this.Bank_list.push(x);
        }
        // this.rows = response.Data.reverse();
        // console.log(this.rows);
      }
    );



  }

  product_list_get() {
    let a = {
      client_id : this.getFromLocal("Client_ID")
    }
    this._api.product_type_list(a).subscribe(
      (response: any) => {
        this.product_list = response.Data;
        this.original_product_list = response.Data;
      }
    );
  }


  portfolio_list_get() {
    let a = {
      client_id : this.getFromLocal("Client_ID")
    }
    this._api.portfolio_type_list(a).subscribe(
      (response: any) => {
        this.original_portfolio_list = response.Data;
        let list = response.Data.reverse();
        for (let i = 0; i < list.length; i++) {
          let obj = { "y": list[i].portfolio_type};
          this.portfolio_list.push(obj);
        }
        this.booleans = true;
      }
    );
  }

  fetchuser_1(){
    // debugger
    for(let a = 0 ; a < this.original_bank_list.length ; a ++){
     if(this.original_bank_list[a].bank_name == this.Bank_list_gets.y){
       this.bank_id = this.original_bank_list[a]._id;
     }
   }
     let a = {
       client_id : this.getFromLocal("Client_ID"),
       bank_id : this.bank_id
     }
     this._api.portfolio_type_list_bank_id(a).subscribe(
       (response: any) => {
         this.portfolio_list = [];
         this.original_portfolio_list = response.Data;
         let list = response.Data.reverse();
         for (let i = 0; i < list.length; i++) {
           let obj = { "y": list[i].portfolio_type};
           this.portfolio_list.push(obj);
         }
         this.booleans = true;
       }
     );
   }


    saveInLocal(key, val): void {
    this.storage.set(key, val);
  }

  getFromLocal(key): any {
    return this.storage.get(key);
  }




  onFileChange(event: any) {
    this.excel_data = [];
    this.file = event.target.files[0];

    let fileReader = new FileReader();
    fileReader.onload = (e) => {
      try {
        let arrayBuffer = fileReader.result;
        if (arrayBuffer instanceof ArrayBuffer) {
          let data = new Uint8Array(arrayBuffer);

          let arr = new Array<string>();

          for (let i = 0; i < data.length; ++i) {
            arr[i] = String.fromCharCode(data[i]);
          }

          let bstr = arr.join("");
          let workbook = XLSX.read(bstr, { type: "binary" });
          let first_sheet_name = workbook.SheetNames[0];
          let worksheet = workbook.Sheets[first_sheet_name];

          let arraylist = XLSX.utils.sheet_to_json(worksheet, { raw: true });

          const excelDataArray: any = arraylist.map((excelData: any) => {
            const cleanedData: any = {} as any;
            console.log("excelData",excelData);

            for (const key in excelData as Record<string, unknown>) {
              if (Object.prototype.hasOwnProperty.call(excelData, key)) {
                if (key === 'passport_no' || key === 'acc_no') {
                  cleanedData[key] = typeof excelData[key] === 'string'
                    ? this.removeChars(excelData[key].trim())
                    : excelData[key];
                } else {
                  cleanedData[key] = excelData[key];
                }
              }
            }
            return cleanedData;
          });

          this.excel_data = excelDataArray;

          console.log(arraylist);
        } else {
          console.error('The file content is not in the expected format (ArrayBuffer).');
          // Handle the error or notify the user
        }
      } catch (error) {
        console.error('Error reading or parsing the file:', error);
        // Handle the error appropriately, e.g., show a message to the user
      }
    };

    fileReader.readAsArrayBuffer(this.file);
  }








  closeExcel() {
    this.fileControl.nativeElement.value = null;
  }


  checknow(){
    this.loader_status = true;
    let data = {
      excelData : this.excel_data,
      "bucket_details" : ""+this.bucket_details,
      "client_id" : this.getFromLocal("Client_ID"),
      "bank_id" : this.bank_id,
      "product_id" : this.product_id,
      "porfolio_id" : this.portfolio_id,
      "bucket_id" :""+this.bucket_details,
      "added_by":  this.getFromLocal("User_ID"),
      "added_at":  ""+new Date(),
    }
    console.log(data);

    this._api.insert_excel_data(data).subscribe(
      (response: any) => {
        console.log(response.Data);
        console.log(response.Message);
        response.allocation_check = "Allocated";
        alert(response.Message);
        this.loader_status = false;
      }
    );

    this.Last_existing_count = 0;
    // this.timeLeft = this.excel_data.length - 1;
    // this.interval = setInterval(() => {
    //   if(this.timeLeft > -1) {
    //     let a = {
    //          "nationality" : this.excel_data[this.timeLeft].nationality,
    //          "cycle" : this.excel_data[this.timeLeft].cycle,
    //          "flow_status" : this.excel_data[this.timeLeft].flow_status,
    //          "product_name" : this.excel_data[this.timeLeft].product_name,
    //          "bank_allocation" : this.excel_data[this.timeLeft].bank_allocation,
    //          "bucket" : this.excel_data[this.timeLeft].bucket,
    //          "passport_no": this.excel_data[this.timeLeft].passport_no,
    //          "acc_no": this.excel_data[this.timeLeft].acc_no,
    //          "cif":  this.excel_data[this.timeLeft].cif || "",
    //          "agreement_id":  this.excel_data[this.timeLeft].agreement_id,
    //          "total_out_standing":  this.excel_data[this.timeLeft].total_out_standing,
    //          "customer_details" : [this.excel_data[this.timeLeft]],
    //          "bucket_details" : ""+this.bucket_details,
    //          "client_id" : this.getFromLocal("Client_ID"),
    //          "bank_id" : this.bank_id,
    //          "product_id" : this.product_id,
    //          "porfolio_id" : this.portfolio_id,
    //          "bucket_id" :""+this.bucket_details,
    //          "added_by":  this.getFromLocal("User_ID"),
    //          "added_at":  ""+new Date(),
    //          "allocation_check" : this.excel_data[this.timeLeft].allocation_check,
    //          "fint_id" : this.excel_data[this.timeLeft].fint_id,
    //          "user_id" : this.excel_data[this.timeLeft].user_id
    //     }
    //     console.log(a);
    //     let temp_no = this.timeLeft;
    //     this._api.insert_excel_data(a).subscribe(
    //       (response: any) => {
    //         console.log(response.Data);
    //         console.log(response.Message);
    //           this.excel_data[temp_no].allocation_check = "Allocated";
    //         this.timeLeft--;
    //       }
    //     );

    //   } else {
    //     this.timeLeft = -1;
    //     this.loader_status = false;
    //   }
    // },2000);
  }


  export(): void {
    /* generate worksheet */
    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(this.excel_data);
    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    /* save to file */
    XLSX.writeFile(wb, this.fileName);
  }


  exportAsXLSX(): void {
    this.excelService.exportAsExcelFile(this.excel_data,'Fint_Gen');
  }


  entry(){

    this.bank_id = '';
    this.product_id = '';
    this.portfolio_id = '';



    for(let v = 0 ; v < this.original_product_list.length ; v ++){
         if(this.original_product_list[v]._id == this.product_list_gets){
           this.product_name = this.original_product_list[v].product_type;
         }
    }
    for(let a = 0 ; a < this.original_bank_list.length ; a ++){
      if(this.original_bank_list[a].bank_name == this.Bank_list_gets.y){
        this.bank_id = this.original_bank_list[a]._id;
      }
      if(a == this.original_bank_list.length - 1){
      for(let b = 0 ; b < this.original_portfolio_list.length ; b ++){
        if(this.original_portfolio_list[b].portfolio_type == this.portfolio_list_gets.y){
          this.portfolio_id = this.original_portfolio_list[b]._id;
        }
      if(b == this.original_portfolio_list.length - 1){
      this.product_id = this.product_list_gets;
          }
        }
      }
    }



    console.log(this.bank_id,this.product_id,this.portfolio_id,this.product_name);
    this.fetch_bucket();

  }

  fetch_bucket(){
    let a  = {
      bank_id : this.bank_id,
      portfolio_id : this.portfolio_id
    }
    console.log(a);
    this._api.get_bucket_detail(a).subscribe(
      (response: any) => {
       console.log(response);
       if(response.Data == null){
        this.bucket_details = ""+new Date().getTime();
        console.log(this.bucket_details,"false");
       }else {

        this.bucket_details = response.Data.bucket_id;
        console.log(this.bucket_details,"ture");

       }
      }
    );

    this.upload_visible = true;

  }



}
